<div class="wrapper p-4" *ngIf="loaded">
  <div class="session-content p-4">
    <div class="justify-content-between d-flex align-items-center">
      <div class="justify-content-between d-flex align-items-center w-100 **:">
        <div class=" d-flex align-items-center go-back" style="cursor: pointer" (click)="goBack()">
          <fa-icon class="icon-go-back" [icon]="faArrowLeft"></fa-icon>
          <p class="mb-0">Volver</p>
        </div>
        
        <div class=" d-flex align-items-center go-register" style="cursor: pointer" (click)="goToCashRegisterReport()">
          <fa-icon class="" [icon]="faFileInvoiceDollar"></fa-icon>
          <p class="mb-0 black-link-text">Ver informes de sesiones - Histórico</p>
        </div>

      </div>

    </div>
    <div class="d-flex flex-column align-items-center">

      <div class="d-flex justify-content-between align-items-center w-85" style="width: 80%;">

        <p style="
          font-size: 34px;
          font-weight: 500;
          text-align: start;
          font-family: 'ClashDisplay-Medium';
        ">
          Detalles de la <span class="pink-text">sesión {{ sessionId }}</span> de la caja
          <span class="pink-text">{{ session.cash_register }}</span>
        </p>

        <div class="d-flex gap-3 align-items-center">

          <div class="btn-close d-flex align-items-center download-report" *ngIf="!session.work_time_closed"
            (click)="closeWorkTime()" style="cursor: pointer">
            <fa-icon [icon]="faArrowRightFromBracket"></fa-icon>
            <p class="m-0">Cerrar caja</p>
          </div>
          <div class="btn-primary d-flex align-items-center download-report"
            (click)="downloadReport(sessionId, 'sesion_' + sessionId)" style="cursor: pointer">
            <fa-icon [icon]="faFileArrowDown"></fa-icon>
            <p class="m-0">Resumen</p>
          </div>
        </div>
      </div>
    </div>

    <div class="resume-card">
      <div style="border: solid 2px #FF4D80;">
        <p class="card-title">Caja inicial</p>
        <p style="font-size: 24px;">+{{ formatNumber(session.initial_balance) }}</p>
      </div>
      <div>
        <p class="card-title">Total TPV</p>
        <p style="font-size: 21px; color: #21CB7C;">+{{ formatNumber(session.totals.total_tpv) }}</p>
      </div>
      <div>
        <p class="card-title">Devoluciones TPV</p>
        <p style="font-size: 21px; color: #DC1C1C;">-{{ formatNumber(session.totals.total_tpv_refunds) }}</p>
      </div>
      <span></span>
      <div>
        <p class="card-title">Total efectivo</p>
        <p style="font-size: 21px; color: #21CB7C;">+{{ formatNumber(session.totals.total_cash) }}</p>
      </div>
      <div>
        <p class="card-title">Devoluciones efectivo</p>
        <p style="font-size: 21px; color: #DC1C1C;">-{{ formatNumber(session.totals.total_cash_refunds) }}</p>
      </div>
      <div style="border: solid 2px #FF4D80;">
        <p class="card-title">Caja final</p>
        <p style="font-size: 24px;">+{{formatNumber(session.totals.total)}}</p>
      </div>
    </div>
    <div class="filters">

      <div class="search-bar">
        <fa-icon class="search-icon" [icon]="faSearch"></fa-icon>
        <input type="text" class="search-input" placeholder="Buscar pedido" [(ngModel)]="searchText"
          (change)="searchTransaction()">
      </div>
      <div class="select-status">
        <i class="far fa-chevron-down icon"></i>
        <!-- <fa-icon class="icon" [icon]="faChevronDown"></fa-icon> -->
        <mat-select [placeholder]="'Elegir'" [(value)]="selectedStatus"
          (selectionChange)="filterTransactions(selectedStatus)">
          <mat-option value="all">Todos</mat-option>
          <mat-option value="sell">Pagos</mat-option>
          <mat-option value="refund">Devoluciones</mat-option>
        </mat-select>
      </div>

    </div>
    <div class="tabs-container">

      <mat-tab-group class="custom-tabs" mat-stretch-tabs="false" mat-align-tabs="start" fitInkBarToContent
        (selectedTabChange)="tabChanged($event)">
        <mat-tab label="Todas las transacciones">

          <div class="table" style="margin-top: 20px; width: 95%;">
            <div class="row table-header align-items-center justify-content-between">
              <div class="col-1">Imprimir</div>
              <div class="col-1 text-center">Tipo</div>
              <div class="col-1 text-center">ID pedido</div>
              <div class="col-2 text-center" (click)="sortTransactions()" style="cursor: pointer;">
                Fecha y hora trans.
                <fa-icon class="short-icon" *ngIf="sortOrder === 'asc'" [icon]="faArrowUp"></fa-icon>
                <fa-icon class="short-icon" *ngIf="sortOrder === 'desc'" [icon]="faArrowDown"></fa-icon>
              </div>
              <div class="col-1 text-center">Canal</div>
              <div class="col-1 text-center">Efectivo</div>
              <div class="col-1 text-center">Cambio</div>
              <div class="col-1 text-center">Total</div>
            </div>

            <!-- Filas de datos con Infinite Scroll -->
            <div class="row table-rows align-items-center justify-content-between"
              *ngFor="let transaction of displayedSessions">
              <div class="col-1 d-flex justify-content-center">
                <fa-icon [icon]="faReceipt"
                  *ngIf="!transaction.transaction_refund && getJsonSeats(transaction.transaction_register?.seats)?.length > 0"
                  class="table-icon"
                  (click)="viewTicket(transaction.id_sale_channel, transaction.transaction_register.id)"></fa-icon>
                <fa-icon [icon]="faReceipt"
                  *ngIf=" transaction.transaction_refund || getJsonSeats(transaction.transaction_register?.seats)?.length <= 0"
                  class="table-icon-disabled"></fa-icon>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p>{{ transaction.transaction_refund ? 'Devolución' : 'Venta' }}</p>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p class="clickable-text" (click)="goToDetail(transaction.transaction_register.id)"
                  *ngIf="!transaction?.transaction_refund">{{ transaction.transaction_register.num_ticket }}</p>
                <p class="clickable-text" (click)="goToDetail(transaction?.transaction_refund.id_transaction)"
                  *ngIf="transaction?.transaction_refund">
                  {{ transaction?.transaction_refund.transaction_register.num_ticket }}</p>
              </div>
              <div class="col-2 d-flex justify-content-center">
                <p>{{ transaction.created_at | date : "dd/MM/yy - HH:mm" }}</p>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p *ngIf="transaction.id_sale_channel == 2">Datáfono/TPV</p>
                <p *ngIf="transaction.id_sale_channel == 3">Efectivo</p>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p *ngIf="!transaction?.transaction_refund && transaction.id_sale_channel == 3">
                  {{ formatNumber(transaction.transaction_register.cash) }}</p>
                <p *ngIf="transaction?.transaction_refund && transaction.id_sale_channel == 3">
                  {{ formatNumber(transaction.amount) }}</p>
                <p *ngIf="transaction.id_sale_channel != 3">-</p>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p *ngIf="!transaction?.transaction_refund && transaction.id_sale_channel == 3">
                  {{ formatNumber(transaction.transaction_register.change) }}</p>
                <p *ngIf="transaction?.transaction_refund && transaction.id_sale_channel == 3">
                  -</p>
                <p *ngIf="transaction.id_sale_channel != 3">-</p>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p *ngIf="!transaction?.transaction_refund " style="color: #21CB7C;">
                  {{'+' + formatNumber(transaction.amount) }}
                </p>
                <p *ngIf="transaction?.transaction_refund" style="color: #DC1C1C;">
                  {{'-'+formatNumber(transaction.transaction_refund.total_refunded)}}</p>
              </div>
            </div>
          </div>

        </mat-tab>
        <mat-tab label="TPV">

          <div class="table" style="margin-top: 20px; width: 95%;">
            <div class="row table-header align-items-center justify-content-between">
              <div class="col-1">Imprimir</div>
              <div class="col-1 text-center">Tipo</div>
              <div class="col-1 text-center">ID pedido</div>
              <div class="col-2 text-center" (click)="sortTransactions()" style="cursor: pointer;">
                Fecha y hora trans.
                <fa-icon class="short-icon" *ngIf="sortOrder === 'asc'" [icon]="faArrowUp"></fa-icon>
                <fa-icon class="short-icon" *ngIf="sortOrder === 'desc'" [icon]="faArrowDown"></fa-icon>
              </div>
              <div class="col-1 text-center">Canal</div>
              <div class="col-1 text-center">Efectivo</div>
              <div class="col-1 text-center">Cambio</div>
              <div class="col-1 text-center">Total</div>
            </div>

            <!-- Filas de datos con Infinite Scroll -->
            <div class="row table-rows align-items-center justify-content-between"
              *ngFor="let transaction of displayedSessions">
              <div class="col-1 d-flex justify-content-center">
                <fa-icon [icon]="faReceipt"
                  *ngIf="!transaction.transaction_refund && getJsonSeats(transaction.transaction_register?.seats)?.length > 0"
                  class="table-icon"
                  (click)="viewTicket(transaction.id_sale_channel, transaction.transaction_register.id)"></fa-icon>
                <fa-icon [icon]="faReceipt"
                  *ngIf=" transaction.transaction_refund || getJsonSeats(transaction.transaction_register?.seats)?.length <= 0"
                  class="table-icon-disabled"></fa-icon>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p>{{ transaction.transaction_refund ? 'Devolución' : 'Venta' }}</p>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p class="clickable-text" (click)="goToDetail(transaction.transaction_register.id)"
                  *ngIf="!transaction?.transaction_refund">{{ transaction.transaction_register.num_ticket }}</p>
                <p class="clickable-text" (click)="goToDetail(transaction?.transaction_refund.id_transaction)"
                  *ngIf="transaction?.transaction_refund">
                  {{ transaction?.transaction_refund.transaction_register.num_ticket }}</p>
              </div>
              <div class="col-2 d-flex justify-content-center">
                <p>{{ transaction.created_at | date : "dd/MM/yy - HH:mm" }}</p>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p *ngIf="transaction.id_sale_channel == 2">Datáfono/TPV</p>
                <p *ngIf="transaction.id_sale_channel == 3">Efectivo</p>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p *ngIf="!transaction?.transaction_refund && transaction.id_sale_channel == 3">
                  {{ formatNumber(transaction.transaction_register.cash) }}</p>
                <p *ngIf="transaction?.transaction_refund && transaction.id_sale_channel == 3">
                  {{ formatNumber(transaction.amount) }}</p>
                <p *ngIf="transaction.id_sale_channel != 3">-</p>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p *ngIf="!transaction?.transaction_refund && transaction.id_sale_channel == 3">
                  {{ formatNumber(transaction.transaction_register.change) }}</p>
                <p *ngIf="transaction?.transaction_refund && transaction.id_sale_channel == 3">-</p>
                <p *ngIf="transaction.id_sale_channel != 3">-</p>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p *ngIf="!transaction?.transaction_refund " style="color: #21CB7C;">
                  {{'+' + formatNumber(transaction.amount) }}
                </p>
                <p *ngIf="transaction?.transaction_refund" style="color: #DC1C1C;">
                  {{'-'+formatNumber(transaction.transaction_refund.total_refunded)}}</p>
              </div>
            </div>
          </div>

        </mat-tab>
        <mat-tab label="Efectivo">

          <div class="table" style="margin-top: 20px; width: 95%;">
            <div class="row table-header align-items-center justify-content-between">
              <div class="col-1">Imprimir</div>
              <div class="col-1 text-center">Tipo</div>
              <div class="col-1 text-center">ID pedido</div>
              <div class="col-2 text-center" (click)="sortTransactions()" style="cursor: pointer;">
                Fecha y hora trans.
                <fa-icon class="short-icon" *ngIf="sortOrder === 'asc'" [icon]="faArrowUp"></fa-icon>
                <fa-icon class="short-icon" *ngIf="sortOrder === 'desc'" [icon]="faArrowDown"></fa-icon>
              </div>
              <div class="col-1 text-center">Canal</div>
              <div class="col-1 text-center">Efectivo</div>
              <div class="col-1 text-center">Cambio</div>
              <div class="col-1 text-center">Total</div>
            </div>

            <!-- Filas de datos con Infinite Scroll -->
            <div class="row table-rows align-items-center justify-content-between"
              *ngFor="let transaction of displayedSessions">
              <div class="col-1 d-flex justify-content-center">
                <fa-icon [icon]="faReceipt"
                  *ngIf="!transaction.transaction_refund && getJsonSeats(transaction.transaction_register?.seats)?.length > 0"
                  class="table-icon"
                  (click)="viewTicket(transaction.id_sale_channel, transaction.transaction_register.id)"></fa-icon>
                <fa-icon [icon]="faReceipt"
                  *ngIf=" transaction.transaction_refund || getJsonSeats(transaction.transaction_register?.seats)?.length <= 0"
                  class="table-icon-disabled"></fa-icon>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p>{{ transaction.transaction_refund ? 'Devolución' : 'Venta' }}</p>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p class="clickable-text" (click)="goToDetail(transaction.transaction_register.id)"
                  *ngIf="!transaction?.transaction_refund">{{ transaction.transaction_register.num_ticket }}</p>
                <p class="clickable-text" (click)="goToDetail(transaction?.transaction_refund.id_transaction)"
                  *ngIf="transaction?.transaction_refund">
                  {{ transaction?.transaction_refund.transaction_register.num_ticket }}</p>
              </div>
              <div class="col-2 d-flex justify-content-center">
                <p>{{ transaction.created_at | date : "dd/MM/yy - HH:mm" }}</p>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p *ngIf="transaction.id_sale_channel == 2">Datáfono/TPV</p>
                <p *ngIf="transaction.id_sale_channel == 3">Efectivo</p>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p *ngIf="!transaction?.transaction_refund && transaction.id_sale_channel == 3">
                  {{ formatNumber(transaction.transaction_register.cash) }}</p>
                <p *ngIf="transaction?.transaction_refund && transaction.id_sale_channel == 3">
                  {{ formatNumber(transaction.amount) }}</p>
                <p *ngIf="transaction.id_sale_channel != 3">-</p>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p *ngIf="!transaction?.transaction_refund && transaction.id_sale_channel == 3">
                  {{ formatNumber(transaction.transaction_register.change) }}</p>
                <p *ngIf="transaction?.transaction_refund && transaction.id_sale_channel == 3">-</p>
                <p *ngIf="transaction.id_sale_channel != 3">-</p>
              </div>
              <div class="col-1 d-flex justify-content-center">
                <p *ngIf="!transaction?.transaction_refund " style="color: #21CB7C;">
                  {{'+' + formatNumber(transaction.amount) }}
                </p>
                <p *ngIf="transaction?.transaction_refund" style="color: #DC1C1C;">
                  {{'-'+formatNumber(transaction.transaction_refund.total_refunded)}}</p>
              </div>
            </div>
          </div>

        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>